import { render, staticRenderFns } from "./AttendanceRules.vue?vue&type=template&id=b9413b0c&"
import script from "./AttendanceRules.vue?vue&type=script&lang=js&"
export * from "./AttendanceRules.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceRules.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports